import { DataObject } from '@shared/models/data-object.model';
import { LatLng, LatLngBounds } from 'leaflet';

export enum GeoPolygonType {
  geoPolygon = 'geoPolygon',
  geoDistance = 'geoDistance',
}

export enum LeafletShape {
  Polygon = 'polygon',
  Circle = 'circle',
}

export enum LeafletPosition {
  TopLeft = 'topleft',
  TopRight = 'topright',
  BottomLeft = 'bottomleft',
  BottomRight = 'bottomright',
}

export enum SearchMode {
  Default = '',
  AsIMove = 'asMove',
}

export interface LatLong {
  lat: number;
  long: number;
}
export interface GeoPolygon {
  type: GeoPolygonType;
  location?: LatLong | LatLong[];
  distance?: number | string;
}

export interface LMapOptions {
  center?: [number, number];
  layers?: any[];
  zoom?: number;
  minZoom?: number;
  maxZoom?: number;
}

/* CONSTANTS */
const southWest = new LatLng(-89.98155760646617, -180);
const northEast = new LatLng(89.99346179538875, 180);
export const WORLD_BOUNDS = new LatLngBounds(southWest, northEast);

const usSouthWest = new LatLng(32.069947, -127.043329);
const usNorthEast = new LatLng(47.356681, -68.331896);
export const UNITED_STATES_BOUNDS = new LatLngBounds(usSouthWest, usNorthEast);

export const DEFAULT_MAP_OPTIONS = {
  zoom: 4,
  maxZoom: 18,
  minZoom: 3,
};

export enum MetricConversion {
  footInAMeter = 3.28084,
  footInAMile = 5280,
}

export const leafLetOptionsFactory = (isUSAUser: boolean) => ({
  position: LeafletPosition.TopLeft,
  draw: {
    polyline: false,
    rectangle: false,
    marker: false,
    circlemarker: false,
    circle: {
      metric: !isUSAUser,
      feet: isUSAUser,
    },
  },
  edit: false,
});
export interface CardViewDataModel {
  // object of the entity's record
  data: DataObject;
  // name of entity
  entity: string;
  // object that brings the translated texts. by default
  localeText: DataObject;
  // country description code
  countryCodeDesc: string;
  // object with the colloquial that does not come within the record (data)
  dataColloquial?: DataObject;
  // array locale area UOM
  localAreaUom?: DataObject[];
}

export type CardFactoryFn = (cardView: CardViewDataModel) => string;
export interface EntityInfoColloquialModel {
  [key: string]: {
    // name of entity
    entity: string;
    // method for obtaining the id for the search of the record for the extraction of its colloquial
    getId: (record: DataObject) => number;
  };
}
